import { AssignmentAttendanceModalComponent } from './components/details/c/assignment-attendance-modal/assignment-attendance-modal.component';
import { AssignmentAttendanceComponent } from './components/details/c/assignment-attendance/assignment-attendance.component';
import { AssignmentCommunicationFeedbackModalComponent } from './components/details/c/assignment-communication/assignment-communication-feedback-modal/assignment-communication-feedback-modal.component';
import { AssignmentCommunicationFeedbackComponent } from './components/details/c/assignment-communication/assignment-communication-feedback/assignment-communication-feedback.component';
import { AssignmentCommunicationNotesModalComponent } from './components/details/c/assignment-communication/assignment-communication-notes-modal/assignment-communication-notes-modal.component';
import { AssignmentCommunicationNotesComponent } from './components/details/c/assignment-communication/assignment-communication-notes/assignment-communication-notes.component';
import { AssignmentCommunicationUpdateModalComponent } from './components/details/c/assignment-communication/assignment-communication-update-modal/assignment-communication-update-modal.component';
import { AssignmentCommunicationUpdateComponent } from './components/details/c/assignment-communication/assignment-communication-update/assignment-communication-update.component';
import { AssignmentCommunicationComponent } from './components/details/c/assignment-communication/assignment-communication.component';
import { AssignmentDatesComponent } from './components/details/c/assignment-dates/assignment-dates.component';
import { AssignmentCancelSubstituteSearchModalComponent } from './components/details/c/assignment-information/assignment-cancel-cancel-substitute-search-modal/assignment-cancel-substitute-search-modal.component';
import { AssignmentCancelModalComponent } from './components/details/c/assignment-information/assignment-cancel-modal/assignment-cancel-modal.component';
import { AssignmentInformationComponent } from './components/details/c/assignment-information/assignment-information.component';
import { AssignmentInstructorsComponent } from './components/details/c/assignment-instructores/assignment-instructors.component';
import { AssignmentParticipantSkillsModalComponent } from './components/details/c/assignment-participant-skills-modal/assignment-participant-skills-modal.component';
import { AssignmentContactParticipantsComponent } from './components/details/c/assignment-participants/assignment-contact-participants/assignment-contact-participants.component';
import { AssignmentParticipantRegistrationDetailsExportComponent } from './components/details/c/assignment-participants/assignment-participant-registration-details-export/assignment-participant-registration-details-export.component';
import { AssignmentParticipantRegistrationDetailsModalComponent } from './components/details/c/assignment-participants/assignment-participant-registration-details-modal/assignment-participant-registration-details-modal.component';
import { AssignmentContactParticipantsModalComponent } from './components/details/c/assignment-participants/assignment-participants-contacting-modal/assignment-participants-contacting-modal.component';
import { AssignmentParticipantsListComponent } from './components/details/c/assignment-participants/assignment-participants-list/assignment-participants-list.component';
import { AssignmentParticipantsComponent } from './components/details/c/assignment-participants/assignment-participants.component';
import { AssignmentSportskillsComponent } from './components/details/c/assignment-sportskills/assignment-sportskills.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { MarkdownModule } from 'ngx-markdown';
import { QuillModule } from 'ngx-quill';

import { SharedModule } from '../shared/shared.module';
import { AssignmentRoutingModule } from './assignment-routing.module';
import { AssignmentSummaryModalComponent } from './components/assignment-summary-modal/assignment-summary-modal.component';
import { AssignmentsFilterModalComponent } from './components/assignments-filter-modal/assignments-filter-modal.component';
import { AssignmentsLayoutComponent } from './components/assignments-layout/assignments-layout.component';
import { AssignmentsPageComponent } from './components/assignments-page/assignments-page.component';
import { BilledAssignmentItemComponent } from './components/billed-assignment-item/billed-assignment-item.component';
import { BilledAssignmentsPeriodDetailsComponent } from './components/billed-assignments-period-details/billed-assignments-period-details.component';
import { BilledAssignmentsPeriodComponent } from './components/billed-assignments-period/billed-assignments-period.component';
import { BilledAssignmentsComponent } from './components/billed-assignments/billed-assignments.component';
import { AssigmentDetailsComponent } from './components/details/assignment-details.component';
import { ExchangeAssignmentsModalComponent } from './components/exchange-assignments-modal/exchange-assignments-modal.component';
import { ExchangeAssignmentsComponent } from './components/exchange-assignments/exchange-assignments.component';
import { FilterDisplayItemComponent } from '../shared/components/filter-display-item/filter-display-item.component';
import { FilterDisplayComponent } from './components/assignments-filter-display/assignments-filter-display.component';
import { MyAssignmentsComponent } from './components/my-assignments/my-assignments.component';
import { OpenAssignmentsModalComponent } from './components/open-assignments-modal/open-assignments-modal.component';
import { OpenAssignmentsComponent } from './components/open-assignments/open-assignments.component';
import { PastAssignmentsComponent } from './components/past-assignments/past-assignments.component';

@NgModule({
    imports: [
        NgSelectModule,
        CommonModule,
        SharedModule,
        AssignmentRoutingModule,
        QuillModule.forRoot(),
        MarkdownModule.forRoot()
    ],
    declarations: [
        AssignmentsLayoutComponent,
        AssignmentsPageComponent,
        ExchangeAssignmentsComponent,
        ExchangeAssignmentsModalComponent,
        OpenAssignmentsComponent,
        OpenAssignmentsModalComponent,
        PastAssignmentsComponent,
        BilledAssignmentsComponent,
        BilledAssignmentsPeriodComponent,
        BilledAssignmentsPeriodDetailsComponent,
        BilledAssignmentItemComponent,
        MyAssignmentsComponent,
        AssignmentSummaryModalComponent,
        AssignmentsFilterModalComponent,
        FilterDisplayComponent,
        AssignmentAttendanceComponent,
        AssignmentCommunicationComponent,
        AssignmentInformationComponent,
        AssignmentParticipantsComponent,
        AssignmentInstructorsComponent,
        AssignmentSportskillsComponent,
        AssignmentCommunicationFeedbackComponent,
        AssignmentCommunicationFeedbackModalComponent,
        AssignmentCommunicationNotesComponent,
        AssignmentCommunicationUpdateComponent,
        AssignmentCommunicationNotesModalComponent,
        AssignmentCommunicationUpdateModalComponent,
        AssignmentContactParticipantsComponent,
        AssignmentContactParticipantsModalComponent,
        AssignmentParticipantsListComponent,
        AssignmentParticipantRegistrationDetailsModalComponent,
        AssignmentParticipantRegistrationDetailsExportComponent,
        AssignmentDatesComponent,
        AssigmentDetailsComponent,
        AssignmentParticipantSkillsModalComponent,
        AssignmentCancelModalComponent,
        AssignmentCancelSubstituteSearchModalComponent,
        AssignmentAttendanceModalComponent
    ],
    exports: [],
    providers: [],
})
export class AssignmentModule { }
